import React, { Component, createRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { REGULAR_PATH } from '../../../env';
import {
  Segment,
  Header,
  Table,
  Loader,
  Modal,
  Button,
  Dimmer,
  Dropdown,
  Search,
  Form,
  Icon,
} from 'semantic-ui-react';
import { observer } from 'mobx-react';
import { alertMessage } from '../../helper/alert-message';
import { postData } from '../../helper/dataService';

const getToken = () => window.localStorage.getItem('user');

@observer
class ManageUser extends Component {
  state = {
    loadingList: false,
    userAssetsLoading: false,
    showModal: false,
    showAddUserModal: false,
    userData: [],
    assetsList: [],
    assetOptions: [],
    selectedAssets: [],
    userAssets: [],
    userAssetsMain: [],
    selectedUserId: null,
    search: '',
    email: '',
    selectedUserEmail: '',
    emailError: '',
    name: '',
    nameError: '',
    loadingEmailSubmit: false,
    loadingDownload: false,
    selectedUserName: '',
    selectedUserIsActive: null,
    loadingAssetSave: false,
    loadingBlockUser: false,
  };

  componentDidMount() {
    this.fetchData();
    this.fetchAssetList();
  }

  fetchAssetList = () => {
    axios
      .get(`${REGULAR_PATH}/assets/bl_assets?access_token=${getToken()}`)
      .then(({ data }) => {
        const assetList = data.data || [];
        const assets = assetList.map((item) => ({
          key: item.asset_id,
          value: item.asset_id,
          text: item.asset_name,
        }));

        this.setState({
          assetsList: assets,
          assetOptions: assets,
        });
      })
      .catch(() => {
        console.error('Failed to fetch asset list');
      });
  };

  fetchData = () => {
    this.setState({ loadingList: true });
    axios
      .get(`${REGULAR_PATH}/assets/bl_users?access_token=${getToken()}`)
      .then(({ data }) => {
        const userData = data.data;
        if (userData) {
          this.setState({
            userData: this.sortUsers(userData),
          });
          this.setState({ loadingList: false });
        }
      })
      .catch(() => {
        this.setState({ loadingList: false });
      });
  };

  handleGetUserAssets = (user) => {
    const userId = user._id ? user._id.$oid : user.email;
    const email = user.email;
    this.setState({
      userAssetsLoading: true,
      selectedUserEmail: email,
      selectedUserName: user.name,
      selectedUserIsActive: user.is_active,
    });

    axios
      .get(
        `${REGULAR_PATH}/assets/bl_user_assets?email=${email}&access_token=${getToken()}`,
      )
      .then(({ data }) => {
        const userAssets = (data.data || []).map((item) => ({
          asset_id: item.asset_id,
          asset_name: item.name,
        }));
        const updatedOptions = this.state.assetsList.filter(
          (asset) =>
            !userAssets.some((userAsset) => userAsset.asset_id === asset.value),
        );

        this.setState({
          userAssets,
          userAssetsMain: userAssets,
          assetOptions: updatedOptions,
          userAssetsLoading: false,
          selectedUserId: userId,
        });
      })
      .catch(() => {
        this.setState({ userAssetsLoading: false });
      });
  };

  handleDownload = () => {
    this.setState({ loadingDownload: true });

    axios
      .get(
        `${REGULAR_PATH}/assets/bl_users_export?access_token=${getToken()}`,
        {
          responseType: 'blob',
        },
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'users_export.csv');
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.setState({ loadingDownload: false });
      })
      .catch((error) => {
        console.error('Failed to download user export', error);
        alertMessage('Failed to download user export', 'error');
        this.setState({ loadingDownload: false });
      });
  };

  handleAssetSelect = (e, data) => {
    this.setState((prevState) => ({
      userAssets: [
        ...prevState.userAssets,
        {
          asset_id: data.value[0],
          asset_name: data.options.find(
            (option) => option.value === data.value[0],
          ).text,
        },
      ],
      assetOptions: prevState.assetOptions.filter(
        (asset) => asset.value !== data.value[0],
      ),
    }));
  };

  handleDelete = (id) => {
    axios
      .put(
        `${REGULAR_PATH}/organization/users?access_token=${getToken()}`,
        JSON.stringify({
          user_oid: id,
        }),
      )
      .then(({ data }) => {
        this.setState((prevState) => ({
          userData: prevState.userData.filter((user) => {
            const userId = user._id ? user._id.$oid : user.email;
            return userId !== id;
          }),
        }));
      });
  };

  handleRemoveAsset = (id) => {
    const { userAssets, assetsList } = this.state;

    const updatedUserAssets = userAssets.filter(
      (asset) => asset.asset_id !== id,
    );

    const finalAssetsList = assetsList.filter(
      (asset) =>
        !updatedUserAssets.some(
          (userAsset) => userAsset.asset_id === asset.value,
        ),
    );

    this.setState({
      userAssets: updatedUserAssets,
      assetOptions: finalAssetsList,
    });
  };

  handleRemoveAll = () => {
    const { assetsList } = this.state;

    this.setState({
      userAssets: [],
      assetOptions: assetsList,
    });
  };

  handleAddAll = () => {
    const { assetOptions, userAssets } = this.state;

    const assets = [...userAssets];

    assetOptions.forEach((asset) => {
      const assetExist = userAssets.find(
        (userAsset) => userAsset.asset_id === asset.value,
      );
      if (!assetExist) {
        assets.push({
          asset_name: asset.text,
          asset_id: asset.value,
        });
      }
    });
    this.setState({
      assetOptions: [],
      userAssets: assets,
    });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
    this.setState({ showAddUserModal: false });
    this.setState({
      email: '',
      emailError: '',
      name: '',
      nameError: '',
    });
  };

  handleUpdateUserAsset = () => {
    const { userAssets, selectedUserId, userData, selectedUserEmail } =
      this.state;

    const assets_oid = userAssets.flatMap((item) => item.asset_id);

    this.setState({ loadingAssetSave: true });
    axios
      .patch(
        `${REGULAR_PATH}/assets/bl_user_assets?email=${selectedUserEmail}&access_token=${getToken()}`,
        JSON.stringify({
          email: selectedUserEmail,
          asset_ids: assets_oid,
          updated_by: window.localStorage.getItem('email'),
        }),
      )
      .then(({ data }) => {
        alertMessage(data.message, 'success');
        this.setState({
          loadingAssetSave: false,
          userData: userData.map((user) => {
            const userId = user._id ? user._id.$oid : user.email;
            if (userId === selectedUserId) {
              return { ...user, number_of_assets: assets_oid.length };
            }
            return user;
          }),
        });
      })
      .catch((err) => {
        console.error('Failed to save assets', err);
        alertMessage('Failed to save assets', 'error');
        this.setState({ loadingAssetSave: false });
      });
  };

  handleBlockUnblockUser = () => {
    const { selectedUserEmail, selectedUserIsActive, userData } = this.state;
    const newStatus = selectedUserIsActive === false ? true : false;

    this.setState({ loadingBlockUser: true });
    axios
      .patch(
        `${REGULAR_PATH}/assets/bl_user_status?access_token=${getToken()}`,
        JSON.stringify({
          email: selectedUserEmail,
          is_active: newStatus,
        }),
      )
      .then(({ data }) => {
        alertMessage(
          data.message ||
            `User ${newStatus ? 'unblocked' : 'blocked'} successfully`,
          'success',
        );
        this.setState({
          loadingBlockUser: false,
          selectedUserIsActive: newStatus,
          userData: userData.map((user) => {
            if (user.email === selectedUserEmail) {
              return { ...user, is_active: newStatus };
            }
            return user;
          }),
        });
      })
      .catch((err) => {
        console.error('Failed to update user status', err);
        alertMessage('Failed to update user status', 'error');
        this.setState({ loadingBlockUser: false });
      });
  };

  handleAddUser = () => {
    const { email, name } = this.state;
    let hasError = false;

    if (!name.trim()) {
      this.setState({ nameError: 'Please enter a name.' });
      hasError = true;
    } else if (name.trim().length < 5) {
      this.setState({ nameError: 'Name must be at least 5 characters long.' });
      hasError = true;
    } else if (name.trim().length > 50) {
      this.setState({ nameError: 'Name cannot exceed 50 characters.' });
      hasError = true;
    } else {
      this.setState({ nameError: '' });
    }

    if (!this.validateEmail(email)) {
      this.setState({ emailError: 'Please enter a valid email address.' });
      hasError = true;
    } else {
      this.setState({ emailError: '' });
    }

    if (hasError) return;

    const data = {
      name,
      email,
      updated_by: window.localStorage.getItem('email'),
    };
    this.setState({ loadingEmailSubmit: true });
    postData(
      `${REGULAR_PATH}/assets/bl_user_add?access_token=${getToken()}`,
      JSON.stringify(data),
    )
      .then(({ data }) => {
        if (data.message === 'success' || data.message === 'User registered') {
          alertMessage('User added successfully.', 'success');
          let newUser = {
            name,
            email,
            number_of_assets: 0,
            modified_at: new Date().toISOString(),
          };

          if (data.data && typeof data.data === 'object') {
            newUser = { ...newUser, ...data.data };
          } else if (data && data.modified_at) {
            newUser = { ...newUser, ...data };
          }

          this.setState((prevState) => ({
            userData: [newUser, ...prevState.userData],
            email: '',
            emailError: '',
            name: '',
            nameError: '',
            showAddUserModal: false,
          }));
        } else {
          alertMessage(data.message || 'Failed to add user', 'error');
        }
        this.setState({ loadingEmailSubmit: false });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ loadingEmailSubmit: false });
      });
  };

  validateEmail = (email) => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  };

  popupRef = createRef();

  closePopup = () => {
    // Simulate a click on the document body to close the popup
    document.body.click();
  };

  getOids = (arr) => arr.map((a) => a.asset_id).sort();

  sortUsers = (users) => {
    return users.sort((a, b) => {
      const nameA = (a.name || '').toLowerCase();
      const nameB = (b.name || '').toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });
  };

  formatDateUTC6 = (dateString) => {
    if (!dateString) return '-';
    return moment(dateString).format('DD/MM/YY, hh:mm a');
  };

  render() {
    const {
      loadingList,
      userData,
      showModal,
      selectedAssets,
      userAssets,
      assetOptions,
      userAssetsLoading,
      search,
      showAddUserModal,
      email,
      name,
      emailError,
      nameError,
      loadingEmailSubmit,
      userAssetsMain,
    } = this.state;

    const disableSave =
      userAssets.length === userAssetsMain.length &&
      JSON.stringify(this.getOids(userAssets)) ===
        JSON.stringify(this.getOids(userAssetsMain));

    const isAuthorizedOrg = ['59ccbc8a1d41c83c9697dc33'].includes(
      window.localStorage.getItem('organization'),
    );
    const isAdmin = window.localStorage.getItem('org_admin') === 'true';

    if (!isAuthorizedOrg || !isAdmin) {
      return <h2>You are not authorized person.</h2>;
    }

    if (loadingList) {
      return (
        <Dimmer active inverted>
          <Loader size='large'>Loading...</Loader>
        </Dimmer>
      );
    }

    const filteredList = userData.filter((item) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(search.toLowerCase()),
      ),
    );

    return (
      <>
        <Segment>
          <Segment>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <Header as='h2'>User Manage</Header>
              </div>
              <div style={{ display: 'flex', gap: 50 }}>
                <div style={{ width: 350 }}>
                  <Search
                    placeholder='Search here'
                    onSearchChange={(_, data) =>
                      this.setState({ search: data.value })
                    }
                    showNoResults={false}
                  />
                </div>
                <div>
                  <Button
                    primary
                    onClick={this.handleDownload}
                    loading={this.state.loadingDownload}
                    disabled={this.state.loadingDownload}
                  >
                    Download
                  </Button>
                </div>
                <div>
                  <Button
                    primary
                    onClick={() => this.setState({ showAddUserModal: true })}
                  >
                    Add User
                  </Button>
                </div>
              </div>
            </div>
          </Segment>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>No</Table.HeaderCell>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Email</Table.HeaderCell>
                <Table.HeaderCell>Number of Assets</Table.HeaderCell>
                <Table.HeaderCell>Modified At</Table.HeaderCell>
                <Table.HeaderCell>Action</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {filteredList.map((user, index) => (
                <Table.Row key={user.email}>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell>{user.name}</Table.Cell>
                  <Table.Cell>{user.email}</Table.Cell>
                  <Table.Cell>
                    <div>
                      <h3>{user.number_of_assets}</h3>
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    {this.formatDateUTC6(user.modified_at)}
                  </Table.Cell>
                  <Table.Cell>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <Button
                        secondary
                        size='mini'
                        onClick={() => {
                          this.setState({ showModal: true });
                          this.handleGetUserAssets(user);
                        }}
                      >
                        Edit
                      </Button>
                      {/* {!user.admin && (
                        <div>
                          <Popup
                            wide
                            trigger={
                              <Button
                                color='red'
                                size='mini'
                                content='Delete'
                                ref={this.popupRef}
                              />
                            }
                            on='click'
                          >
                            <div>
                              <p>Are you sure?</p>
                              <div style={{ display: 'flex', gap: 5 }}>
                                <Button
                                  color='red'
                                  size='mini'
                                  content='Yes'
                                  onClick={() =>
                                    this.handleDelete(
                                      user._id ? user._id.$oid : user.email,
                                    )
                                  }
                                />
                                <Button
                                  size='mini'
                                  color='blue'
                                  content='No'
                                  onClick={this.closePopup}
                                />
                              </div>
                            </div>
                          </Popup>
                        </div>
                      )} */}
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
              {userData.length === 0 && (
                <Table.Row>
                  <Table.Cell colSpan='5' textAlign='center'>
                    No data found
                  </Table.Cell>
                </Table.Row>
              )}
            </Table.Body>
          </Table>
        </Segment>
        <Modal
          size='mini'
          open={showModal}
          closeIcon={true}
          onClose={this.handleCloseModal}
          closeOnDimmerClick={false}
          closeOnEscape={false}
        >
          <Modal.Header>Update Asset</Modal.Header>
          <Modal.Content>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px',
                backgroundColor: '#ffffff',
                border: '1px solid #e1e4e8',
                borderRadius: '8px',
                marginBottom: '25px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              }}
            >
              <div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '8px',
                  }}
                >
                  <div
                    style={{
                      fontSize: '1.25rem',
                      fontWeight: '600',
                      color: '#1f2937',
                    }}
                  >
                    {this.state.selectedUserName || '-'}
                  </div>
                </div>
                <div
                  style={{
                    color: '#6b7280',
                    fontSize: '0.95rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                  }}
                >
                  <Icon name='mail' style={{ margin: 0 }} />{' '}
                  {this.state.selectedUserEmail || '-'}
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                  gap: '8px',
                }}
              >
                {this.state.selectedUserIsActive === false && (
                  <div
                    style={{
                      color: '#9b1c1c',
                      fontSize: '1.25rem',
                      fontWeight: 'bold',
                    }}
                  >
                    This user is blocked
                  </div>
                )}
                <Button
                  color={
                    this.state.selectedUserIsActive === false ? 'green' : 'red'
                  }
                  size='small'
                  icon
                  labelPosition='left'
                  title={
                    this.state.selectedUserIsActive === false
                      ? 'Unblock User'
                      : 'Block User'
                  }
                  onClick={this.handleBlockUnblockUser}
                  loading={this.state.loadingBlockUser}
                  disabled={this.state.loadingBlockUser}
                >
                  <Icon
                    name={
                      this.state.selectedUserIsActive === false
                        ? 'unlock'
                        : 'ban'
                    }
                  />
                  {this.state.selectedUserIsActive === false
                    ? 'Unblock'
                    : 'Block'}
                </Button>
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div
                style={{
                  display: 'flex',
                  gap: 20,
                }}
              >
                <Dropdown
                  placeholder='Select Asset'
                  fluid
                  search
                  selection
                  multiple
                  disabled={this.state.selectedUserIsActive === false}
                  options={assetOptions}
                  value={selectedAssets}
                  onChange={this.handleAssetSelect}
                  style={{ width: 500 }}
                />
                <div style={{ display: 'flex', gap: 8 }}>
                  <Button
                    color='red'
                    onClick={this.handleRemoveAll}
                    disabled={
                      userAssets.length === 0 ||
                      this.state.selectedUserIsActive === false
                    }
                  >
                    Remove All
                  </Button>
                  <Button
                    color='red'
                    onClick={this.handleAddAll}
                    disabled={
                      assetOptions.length === 0 ||
                      this.state.selectedUserIsActive === false
                    }
                  >
                    Add All
                  </Button>
                </div>
              </div>
              <Button
                onClick={this.handleUpdateUserAsset}
                style={{ width: 130 }}
                primary
                loading={this.state.loadingAssetSave}
                disabled={
                  disableSave ||
                  this.state.selectedUserIsActive === false ||
                  this.state.loadingAssetSave
                }
              >
                Save
              </Button>
            </div>

            {userAssetsLoading ? (
              <Dimmer active inverted>
                <Loader size='large'>Loading...</Loader>
              </Dimmer>
            ) : (
              <div style={{ marginTop: 20 }}>
                {userAssets.length > 0 ? (
                  <Table celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>No</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Action</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {userAssets.map((asset, index) => (
                        <Table.Row key={asset.asset_id}>
                          <Table.Cell>{index + 1}</Table.Cell>
                          <Table.Cell>{asset.asset_name}</Table.Cell>
                          <Table.Cell>
                            <Button
                              color='red'
                              size='mini'
                              onClick={() =>
                                this.handleRemoveAsset(asset.asset_id)
                              }
                              disabled={
                                this.state.selectedUserIsActive === false
                              }
                            >
                              Remove
                            </Button>
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                ) : (
                  <div style={{ textAlign: 'center' }}>
                    <h3>No assets assigned</h3>
                  </div>
                )}
              </div>
            )}
          </Modal.Content>
        </Modal>

        {/* Add user modal */}
        <Modal
          size='mini'
          open={showAddUserModal}
          closeIcon={true}
          onClose={this.handleCloseModal}
        >
          <Modal.Header>Add User</Modal.Header>
          <Modal.Content>
            <Form onSubmit={this.handleAddUser}>
              <Form.Input
                required
                label='Name'
                type='text'
                value={name}
                onChange={(e) => this.setState({ name: e.target.value })}
                error={!!nameError}
                placeholder='Enter name'
                style={{ width: '100%' }}
              />
              {nameError && (
                <p
                  style={{
                    color: '#9f3a38',
                    fontSize: '11px',
                    marginTop: '-10px',
                    marginBottom: '10px',
                  }}
                >
                  {nameError}
                </p>
              )}
              <Form.Input
                required
                label='Email'
                type='text'
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                error={!!emailError}
                placeholder='Enter email'
                style={{ width: '100%' }}
              />
              {emailError && (
                <p
                  style={{
                    color: '#9f3a38',
                    fontSize: '11px',
                    marginTop: '-10px',
                    marginBottom: '10px',
                  }}
                >
                  {emailError}
                </p>
              )}

              <Button
                positive
                type='submit'
                style={{ marginTop: 10 }}
                loading={loadingEmailSubmit}
              >
                Submit
              </Button>
            </Form>
          </Modal.Content>
        </Modal>
      </>
    );
  }
}

export default ManageUser;
